import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import api from "../api";
import language from "../../language";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

export const fetchReturnedProducts = async (
  lng = "english",
  { page, limit, id, q, donationNumber, returnId }
) => {
  try {
    const user = await getStorage();

    const options = {
      method: "GET",
      url: `${API_URL}/return-product`,
      params: {
        page,
        limit,
        id,
        q,
        returnId,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    let { data, count, totalRecords } = queryRes.data;

    return !page && !limit ? queryRes.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const fetchReturnedNumber = async () => {
  try {
    const user = await getStorage();

    const options = {
      method: "GET",
      url: `${API_URL}/return-number`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    const queryRes = await api(options);

    let data = queryRes.data;

    return data;
  } catch (error) {
    toastMessage("error", error);
  }
};

export const updateReturnedProducts = async (lng = "english", body) => {
  try {
    const user = await getStorage();

    const options = {
      method: "PUT",
      url: `${API_URL}/return-product`,
      data: body,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].update_data_success);
  } catch (error) {
    toastMessage("error", error);
    throw error;
  }
};

export const deleteReturnedProducts = async (lng = "english", id) => {
  try {
    const user = await getStorage();

    const options = {
      method: "DELETE",
      url: `${API_URL}/return-product`,
      data: {
        id,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    await api(options);

    toastMessage("success", language[lng].delete_data_success);
  } catch (error) {
    toastMessage("error", error);
  }
};
